// extracted by mini-css-extract-plugin
export default {"header":"style_header__NewOq","title":"style_title__l-FbT","deleteButton":"style_deleteButton__qYddL"};